import { render } from "./FormIsolatieaanpakSupportView.vue?vue&type=template&id=1ecd4937"
import script from "./FormIsolatieaanpakSupportView.vue?vue&type=script&lang=js"
export * from "./FormIsolatieaanpakSupportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__